export default "__VITE_ASSET__O0uPykFv__"